var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms"},[_c('p',{staticClass:"terms-title"},[_vm._v(" House730放盤條款與條件 ")]),_c('ul',{staticClass:"terms-line"},_vm._l((_vm.terms),function(item){return _c('li',{key:item.id},[_vm._v(" "+_vm._s(item.data)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }